import { CourseTraditional, LinearPercentages } from "@/models/courses.model";
import { Material } from "@/models/material.model";
import { QueryParams } from "@/models/query-params.model";
import { TraditionalTrail } from "@/models/trail.model";
import { getUserFromStorage } from "@/utils/user-store.util";
import { api } from "../api-config/setup";

export interface IMaterialEvent {
  clientTime?: Date;
  concluded?: Boolean;
  learningObjectiveId?: String;
  materialId?: String;
  skipped?: Boolean;
  stoppedAt?: Number;
}

export interface ITrailEvent {
  id?: String;
  clientTime?: Date;
  learningObjectiveId?: String;
  percentage?: Number;
}

export class TraditionalRest {
  static getCourseTraditionalById(
    courseId: string,
    params: Partial<QueryParams>
  ): Promise<CourseTraditional> {
    const url: string = `/third-party/course-student/${courseId}`;
    return api("/graphs")
      .get(url, { params })
      .then((response) => response.data);
  }

  static getTrailsByChapterId(
    courseId: string,
    chapterId: string,
    params: Partial<QueryParams>
  ): Promise<{ ableToQuiz: boolean; linearTrails: TraditionalTrail[] }> {
    const url: string = `third-party/course-student/${courseId}/chapters/${chapterId}/trails`;
    return api("/graphs")
      .get(url, { params })
      .then((response) => response.data);
  }

  static getMaterialsByTrailId(
    courseId: string,
    trailId: string,
    params: Partial<QueryParams>
  ): Promise<Material[]> {
    const url: string = `third-party/course-student/${courseId}/chapters/trails/${trailId}/materials`;
    return api("/graphs")
      .get(url, { params })
      .then((response) => response.data);
  }

  static getMaterialById(
    learningObjectivesId: string,
    materialId: string,
    params: Partial<QueryParams>
  ): Promise<Material> {
    const url: string = `/learning-objectives/${learningObjectivesId}/materials/${materialId}`;
    return api("/graphs")
      .get(url, { params })
      .then((response) => response.data);
  }

  static trailEvent(
    courseId: string,
    data: ITrailEvent,
    params: Partial<QueryParams>
  ): Promise<void> {
    const userId = getUserFromStorage()?.id;
    const url: string = `course-state/${courseId}/${userId}/add-learning-objective-event`;
    return api("/graphs")
      .post(url, data, { params })
      .then((response) => response.data);
  }

  static materialEvent(
    courseId: string,
    data: IMaterialEvent,
    params: Partial<QueryParams>
  ): Promise<void> {
    const userId = getUserFromStorage()?.id;
    const url: string = `/course-state/${courseId}/${userId}/add-material-event`;
    return api("/graphs")
      .post(url, data, { params })
      .then((response) => response.data);
  }

  static getPercentages(
    courseId: string,
    params: Partial<QueryParams>
  ): Promise<LinearPercentages> {
    const url: string = `/third-party/course-student/${courseId}/percentages`;
    return api("/graphs")
      .get(url, { params })
      .then((response) => response.data);
  }
}
